import { Stack } from "@mui/material";
import { LoadingSpinner } from "@src/appV2/redesign/system/ui-components";

import { PageWrapper } from "../../components/PageWrapper";
import { PageContent } from "../../WorkerShifts/components/PageContent";
import { OnboardingPageHeader, type OnboardingPageHeaderProps } from "../SharedPageHeader";

interface OnboardingPersonalIdVerificationLoadingProps {
  progress: OnboardingPageHeaderProps["progress"];
}

export function OnboardingPersonalIdVerificationLoading({
  progress,
}: OnboardingPersonalIdVerificationLoadingProps) {
  return (
    <PageWrapper variant="tertiary">
      <OnboardingPageHeader hideBackButton progress={progress} />
      <PageContent>
        <Stack alignItems="center" justifyContent="center" flex={1}>
          <LoadingSpinner size="large" variant="primary" />
        </Stack>
      </PageContent>
    </PageWrapper>
  );
}
